import React, {useEffect} from "react"
import {layoutSidebarLeftWidth} from "../settings"
import {iconCopy, iconInfo, iconRemove, iconSettings, iconWallNext, iconWallPrev} from "../Helper/Icons"
import {useHelp, useModal, useRoomParameters, useRoomSetup, useLocal, useMessage} from "../AppContext"
import {useSidebar} from "../Hooks/Sidebar"
import {AddItem} from "../Components/Menu/AddItem"
import {Button} from "../Components/Button"
import {CtaBubble, CtaBubbleLabel} from "../Components/CtaBubble"
import {InputSelect} from "../Components/Input"
import {MenuLeft} from "../Components/MenuLeft"
import {PropertiesSize} from "../Components/SideBar/PropertiesSize"
import {SelectItem} from "../Components/Menu/SelectItem"
import {SideBarRightBody, SideBarRightBodyBlock, SideBarRightBodyBlockLabel, SideBarRightBodyBlockLabelHighlight, SideBarRightHead, SideBarRightHeadItem, SideBarRightLayout, SideBarRightSectionLabel10, SideBarRightSectionLabel20} from "../Components/SideBar/SideBarRight"
import {SideBarRightHandel} from "../Components/SideBar/SideBarRightHandel"
import {SortNote} from "../Components/Menu/SortNote"
import {interiorSort} from "../Helper/InteriorSort"
import style from "./Wall.css"

export const Wall = () => {
    const help = useHelp()
    const roomSetup = useRoomSetup()
    const sidebar = useSidebar(true, true)
    const local = useLocal()

    useEffect(() => {
        roomSetup.unsetHandle()
        help.setContext('fensterundtueren')
    }, [])

    return <>
        <MenuLeft label={local.__("Fenster und Türen")}>
            <Items sidebar={sidebar}/>
            <SortNote/>
        </MenuLeft>
        <Properties sidebar={sidebar}/>
        <CtaBubble name={"wall"} left={layoutSidebarLeftWidth + 40} top={155}>
            <CtaBubbleLabel>
                {local.__("Fenster und Türen")}
            </CtaBubbleLabel>
            <div dangerouslySetInnerHTML={{__html: local.__("Bitte wählen sie ihre Fenster und Türen")}}/>
        </CtaBubble>
    </>
}

const Items = ({sidebar}) => {
    const roomParameters = useRoomParameters()
    const roomSetup = useRoomSetup()
    const local = useLocal()


    const interiorItems = interiorSort(local, [
        ...roomParameters.getInteriors("door", roomSetup.getType()),
        ...roomParameters.getInteriors("window", roomSetup.getType())
    ])

    return interiorItems.map((item) => <Item key={item.id} sidebar={sidebar} item={item}/>)
}

const Item = ({sidebar, item}) => {
    const local = useLocal()
    const message = useMessage()
    const roomSetup = useRoomSetup()

    const add = () => {
        roomSetup.addInterior(item)
        sidebar.open()
        message.showSuccess(local.__("%itemName% wurde positioniert", {itemName: local.getLabel(item.name)}))
    }

    return <AddItem onClick={add}>
        <div className={style.item}>
            <div style={{backgroundImage: `url("${item.previewThumbnail}")`}}/>
            <div>
                {local.getLabel(item.name)}
            </div>
        </div>
    </AddItem>
}

const Properties = ({sidebar}) => {
    const roomSetup = useRoomSetup()
    const local = useLocal()
    const label = local.getLabel(roomSetup.itemGetProperty("name"))

    const open = () => {
        sidebar.open()
    }

    const moveToNextWall = () => {
        roomSetup.itemMoveToNextWall()
    }

    const moveToPrevWall = () => {
        roomSetup.itemMoveToPrevWall()
    }

    const copy = () => {
        roomSetup.itemCopy()
    }

    const remove = () => {
        roomSetup.itemRemove()
    }

    useEffect(() => {
        if (!roomSetup.getHandle()) sidebar.disable()
        else sidebar.enable()
    }, [roomSetup.getHandle()])

    return <SideBarRightHandel sidebar={sidebar}>
        <SideBarRightLayout>
            <SideBarRightHead>
                <SideBarRightHeadItem isDisabled={sidebar.isDisable()} isActive={sidebar.isOpen()} icon={iconSettings} label={label} onClick={open}/>
                <SideBarRightHeadItem isDisabled={sidebar.isDisable()} icon={iconWallNext} label={local.__("auf die nächste Wand verschiebe")} onClick={moveToNextWall}/>
                <SideBarRightHeadItem isDisabled={sidebar.isDisable()} icon={iconWallPrev} label={local.__("auf die vorherige Wand verschiebe")} onClick={moveToPrevWall}/>
                <SideBarRightHeadItem isDisabled={sidebar.isDisable()} icon={iconCopy} label={local.__("duplizieren")} onClick={copy}/>
                <SideBarRightHeadItem isDisabled={sidebar.isDisable()} icon={iconRemove} label={local.__("entfernen")} onClick={remove}/>
            </SideBarRightHead>
            <SideBarRightBody isOpen={sidebar.isOpen()} key={roomSetup.getHandle()}>
                <DoorProperties/>
                <WindowProperties/>
            </SideBarRightBody>
        </SideBarRightLayout>
    </SideBarRightHandel>
}

const DoorProperties = () => {
    const roomSetup = useRoomSetup()
    const local = useLocal()

    if (!roomSetup.itemIsDoor()) return null

    return <>
        {/*<DoorIsMountingSurface/>*/}
        {!roomSetup.itemIsMountingSurface() && <>
            <PropertiesSize/>
        </>}
        {roomSetup.itemIsMountingSurface() && <>
            <SideBarRightSectionLabel10 label={local.__("Basisinfos")}/>
            <DoorType/>
            <DoorWidth/>
            <DoorHeight/>
            <SideBarRightSectionLabel20 label={local.__("Zusatzinfos")}/>
            <DoorHandlePosition/>
            <DoorOpeningDirection/>
        </>}
    </>
}

const DoorIsMountingSurface = () => {
    const roomSetup = useRoomSetup()
    const local = useLocal()
    const isActive = roomSetup.itemIsMountingSurface()
    const modal = useModal()

    const onClick = () => {
        roomSetup.itemToggleMountingSurface()
    }

    const onInfo = (event) => {
        event.stopPropagation()
        modal.openHelp()
    }

    return <SelectItem isActive={isActive} onClick={onClick}>
        <div>{local.__("Können Sie sich vorstellen, die Tür mit Akustik-Absorber zu bekleben?")}</div>
        <Button onClick={onInfo} className={style.isMountingSurfaceInfo}>{iconInfo} {local.__("Info")}</Button>
    </SelectItem>
}

const DoorWidth = () => {
    const roomParameters = useRoomParameters()
    const roomSetup = useRoomSetup()
    const local = useLocal()
    const options = roomParameters.getDoorHandlePositions()
    const value = roomSetup.itemGetDoorHandlePosition()

    const onChange = (event) => {
        roomSetup.itemSetDoorHandlePosition(event.target.value)
    }

    return <SideBarRightBodyBlock>
        <SideBarRightBodyBlockLabel>
            {local.__("DIN")} <SideBarRightBodyBlockLabelHighlight>{local.__("Breite")}</SideBarRightBodyBlockLabelHighlight> {local.__("in cm")}
        </SideBarRightBodyBlockLabel>
        <InputSelect local={local} options={options} value={value} onChange={onChange}/>
    </SideBarRightBodyBlock>
}

const DoorHeight = () => {
    const roomParameters = useRoomParameters()
    const roomSetup = useRoomSetup()
    const local = useLocal()
    const options = roomParameters.getDoorHandlePositions()
    const value = roomSetup.itemGetDoorHandlePosition()

    const onChange = (event) => {
        roomSetup.itemSetDoorHandlePosition(event.target.value)
    }

    return <SideBarRightBodyBlock>
        <SideBarRightBodyBlockLabel>
            {local.__("DIN")} <SideBarRightBodyBlockLabelHighlight>{local.__("Höhe")}</SideBarRightBodyBlockLabelHighlight> {local.__("in cm")}
        </SideBarRightBodyBlockLabel>
        <InputSelect local={local} options={options} value={value} onChange={onChange}/>
    </SideBarRightBodyBlock>
}

const DoorHandlePosition = () => {
    const roomParameters = useRoomParameters()
    const roomSetup = useRoomSetup()
    const local = useLocal()
    const options = roomParameters.getDoorHandlePositions()
    const value = roomSetup.itemGetDoorHandlePosition()

    const onChange = (event) => {
        roomSetup.itemSetDoorHandlePosition(event.target.value)
    }

    return <SideBarRightBodyBlock>
        <SideBarRightBodyBlockLabel label={local.__("Position der Türklinke")}/>
        <InputSelect local={local} options={options} value={value} onChange={onChange}/>
    </SideBarRightBodyBlock>
}

const DoorType = () => {
    const roomParameters = useRoomParameters()
    const roomSetup = useRoomSetup()
    const local = useLocal()
    const options = roomParameters.getDoorTypes()
    const value = roomSetup.itemGetDoorType()

    const onChange = (event) => {
        roomSetup.itemSetDoorType(event.target.value)
    }

    return <SideBarRightBodyBlock>
        <SideBarRightBodyBlockLabel label={local.__("Türausführung")}/>
        <InputSelect local={local} options={options} value={value} onChange={onChange}/>
    </SideBarRightBodyBlock>
}

const DoorOpeningDirection = () => {
    const roomParameters = useRoomParameters()
    const roomSetup = useRoomSetup()
    const local = useLocal()
    const options = roomParameters.getDoorOpeningDirections()
    const value = roomSetup.itemGetDoorOpeningDirection()

    const onChange = (event) => {
        roomSetup.itemSetDoorOpeningDirection(event.target.value)
    }

    return <SideBarRightBodyBlock>
        <SideBarRightBodyBlockLabel label={local.__("Seite der Türöffnung")}/>
        <InputSelect local={local} options={options} value={value} onChange={onChange}/>
    </SideBarRightBodyBlock>
}

const WindowProperties = () => {
    const roomParameters = useRoomParameters()
    const roomSetup = useRoomSetup()
    const local = useLocal()
    const options = roomParameters.getWindowTypes()
    const value = roomSetup.itemGetWindowType()

    const onChange = (event) => {
        roomSetup.itemSetWindowType(event.target.value)
    }

    if (!roomSetup.itemIsWindow()) return null

    return <>
        <PropertiesSize/>
        {/*<SideBarRightSectionLabel20 label={local.__("Zusatzinfos")}/>*/}
        {/*<SideBarRightBodyBlock>*/}
        {/*    <SideBarRightBodyBlockLabel label={local.__("Fensterart")}/>*/}
        {/*    <InputSelect local={local} options={options} value={value} onChange={onChange}/>*/}
        {/*</SideBarRightBodyBlock>*/}
    </>
}
